import {all, call, put, takeLatest} from '@redux-saga/core/effects';
import accountApi from 'Agent/Accounts/api/accountApi';
import {
  EnrollmentApplicationActionType,
  showError,
  uploadApplication,
} from 'Agent/Accounts/ducks/enrollmentApplication';
import {hideModal} from 'Core/ducks/modal';
import {createSnackbar} from 'Core/ducks/snackbar';
import {AsyncResult} from 'Core/models/Async';
import * as E from 'fp-ts/lib/Either';

export function* uploadEnrollmentApplicationApi(action: ReturnType<typeof uploadApplication>) {
  const result: AsyncResult<unknown> = yield call(
    accountApi.uploadEnrollmentApplication,
    action.payload.accountId,
    action.payload.application.accountNumber,
    action.payload.application.servicingAgentNumber.value,
    action.payload.application,
    action.payload.encryptedIdentifier
  );

  if (E.isRight(result)) {
    yield put(hideModal());
    yield put(createSnackbar('Application Uploaded Successfully'));
  } else {
    yield put(showError(action.payload.application));
  }
}

export function* uploadEnrollmentApplicationSaga() {
  yield takeLatest(EnrollmentApplicationActionType.UPLOAD_APPLICATION, uploadEnrollmentApplicationApi);
}

export default function*() {
  yield all([uploadEnrollmentApplicationSaga()]);
}
